/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Money_Total_LabelInputs */

const vi_my_grower_report_money_total_label = /** @type {(inputs: My_Grower_Report_Money_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền đã nhận`)
};

/**

* @param {My_Grower_Report_Money_Total_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_money_total_label = /** @type {((inputs?: My_Grower_Report_Money_Total_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Money_Total_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_money_total_label(inputs)
});